import {
  HIDE_OMAVOINTI_QUESTIONNAIRE_MODAL,
  RECEIVE_QUESTIONNAIRES,
  REQUEST_QUESTIONNAIRES,
  REQUEST_QUESTIONNAIRES_FAILED,
  REQUEST_ALL_COMPLETED_AIVA_PROCESSES,
  RECEIVE_ALL_COMPLETED_AIVA_PROCESSES,
  REQUEST_AIVA_PROCESS,
  RECEIVE_AIVA_PROCESS,
  REQUEST_ALL_COMPLETED_AIVA_PROCESSES_FAILED,
  SHOW_OMAVOINTI_QUESTIONNAIRE_MODAL,
  SET_MOBILE_CLIENT_STATE,
  REQUEST_ASSIGNED_FORMS,
  RECEIVE_ASSIGNED_FORMS,
  REQUEST_ASSIGNED_FORMS_FAILED,
} from './actions';

const initialState = {
  isFetching: false,
  data: [],
  assignedForms: [],
  error: null,
  omavointiQuestionnaireModal: {
    show: false,
    formId: null,
    formCode: null,
  },
  showCoronaQuestionnaireNotification: false,
  mobileClientState: '',
};

export const questionnaireReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_ASSIGNED_FORMS:
      return {
        ...state,
      };
    case REQUEST_ALL_COMPLETED_AIVA_PROCESSES:
      return {
        ...state,
      };
    case REQUEST_AIVA_PROCESS:
      return {
        ...state,
      };
    case RECEIVE_ASSIGNED_FORMS:
      return {
        ...state,
        assignedForms: action.data,
      };
    case RECEIVE_ALL_COMPLETED_AIVA_PROCESSES:
      return {
        ...state,
        aivaProcess: action.data,
      };
    case RECEIVE_AIVA_PROCESS:
      return {
        ...state,
        aivaProcess: action.data,
      };
    case REQUEST_ASSIGNED_FORMS_FAILED:
      return {
        ...state,
        error: action.error,
      };
    case REQUEST_ALL_COMPLETED_AIVA_PROCESSES_FAILED:
      return {
        ...state,
        error: action.error,
      };
    case REQUEST_QUESTIONNAIRES:
      return {
        ...state,
        isFetching: true,
      };
    case RECEIVE_QUESTIONNAIRES:
      return {
        ...state,
        isFetching: false,
        data: action.data,
      };
    case REQUEST_QUESTIONNAIRES_FAILED:
      return {
        ...state,
        isFetching: false,
        error: action.error,
      };
    case SHOW_OMAVOINTI_QUESTIONNAIRE_MODAL:
      return {
        ...state,
        omavointiQuestionnaireModal: {
          show: true,
          formId: action.formId,
          formCode: action.formCode,
        },
      };
    case HIDE_OMAVOINTI_QUESTIONNAIRE_MODAL:
      return {
        ...state,
        omavointiQuestionnaireModal: {
          show: false,
          formId: null,
          formCode: null,
        },
      };
    case SET_MOBILE_CLIENT_STATE: {
      return {
        ...state,
        mobileClientState: action.payload.mobileClientState,
      };
    }
    default:
      return state;
  }
};
